import { useAtom } from "jotai";
import { RiExpandLeftLine, RiExpandRightLine } from "react-icons/ri";

import { IconButton } from "@/components/atoms/IconButton";
import { SideNavigation } from "@/components/organisms/Navigation";
import { tv } from "@/lib/tailwind-variants";
import { sidebarCollapsedAtom } from "@/stores/layout";

import { HeaderLogoLink } from "./HeaderLogoLink";

const sidebarVariants = tv({
  slots: {
    logo: "",
    nav: "grow",
    toggle: "",
  },
  variants: {
    collapsed: {
      true: {
        logo: "grid place-content-center",
        nav: "pl-2",
        toggle: "px-2",
      },
      false: {
        logo: "pl-6",
        nav: "pl-4",
        toggle: "px-4",
      },
    },
  },
});

export const Sidebar = () => {
  const [collapsed, setCollapsed] = useAtom(sidebarCollapsedAtom);
  const { logo, nav, toggle } = sidebarVariants({ collapsed });

  const handleToggleCollapsed = () => {
    setCollapsed((prev) => !prev);
  };

  return (
    <div id="sidebar" className="h-full">
      <div className="sticky top-0 flex h-screen flex-col justify-between gap-6 overflow-auto bg-linear-to-br from-primary from-15% to-[#5549D5] to-100% py-4">
        <div className={logo()}>
          <HeaderLogoLink collapsed={collapsed} />
        </div>
        <nav className={nav()}>
          <SideNavigation />
        </nav>

        <div className={toggle()}>
          <IconButton
            variant="noBgPrimary"
            aria-expanded={!collapsed}
            aria-controls="sidebar"
            ariaLabel={collapsed ? "サイドバーを広げる" : "サイドバーを狭める"}
            onClick={handleToggleCollapsed}
            className="w-full bg-white/15 hover:bg-primary-900 hover:opacity-75 focus-visible:bg-primary-900 focus-visible:opacity-75"
          >
            {collapsed ? (
              <RiExpandRightLine size={20} className="text-white" />
            ) : (
              <RiExpandLeftLine size={20} className="text-white" />
            )}
          </IconButton>
        </div>
      </div>
    </div>
  );
};
